$(document).ready(function()
{

    window.onscroll = function() { myScrollFunction() };

    var preheader = document.getElementById("pre-header");
    var header = document.getElementById("site-header");
    var sticky = header.offsetTop;
    var sticky_body_position = 0;

    function myScrollFunction() 
    {
        if (window.pageYOffset > 40) 
        {
            header.classList.add("sticky");
            $('html').addClass('adjust-sticky'); 
	        $("header").removeClass("show-search");
	        $("body").removeClass("search-active");
            //preheader.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
            $('html').removeClass('adjust-sticky');
            //preheader.classList.remove("sticky");
        }
    }


    $("#primary-nav ul li.menu-item-has-children").on('click', function(e)    
    {
        // tnere is 50px margin right on each of these items
        // therefore if the click happens to be within list item width -50px, then it's on the pseudo el

        var is_active = $(this).hasClass("active");

        if (e.offsetX > (this.offsetWidth - 50))
        {
            // close em all
            $("#primary-nav ul li.menu-item-has-children").removeClass('active');
            // only open if it was closed
            if (!is_active)
            {
                $(this).addClass("active");
            }
        }

    });

    $( ".menu-button" ).click(function()
    {

        if ($("html").hasClass('nav-is-open'))
        {
             $("html").removeClass('nav-is-open');
             // as we use a fixed menu on mobile, the position on screen is lost when the menu is engaged
             window.scrollTo(0, sticky_body_position); 
        }
        else
        {
            sticky_body_position = pageYOffset;  
            $("html").addClass('nav-is-open');
        }

        
    });


    $(".search-trigger").click(function(event) 
    {
        event.preventDefault();
        $("header").toggleClass("show-search");
        $("html").removeClass("nav-is-open");
        $( ".search-input" ).focus();
        $("body").addClass("search-active");
        $("body").addClass("no-scroll")
    });


    $(".search-close").click(function(event) 
    {
    	event.preventDefault();
        $("header").removeClass("show-search");
        $("body").removeClass("search-active");
        $("body").removeClass("no-scroll");
    });

    // RESET THE MENU
    $(window).on('resize', function()
    {
        $("html").removeClass('nav-is-open');
        $("#primary-nav ul li.menu-item-has-children").removeClass('active');
    });

});